import logo from './logo.svg';
import './App.css';
import Sidebar from "./Components/Sidebar/Sidebar";
import {BrowserRouter, Routes, Route} from "react-router-dom";
import Home from "./Components/Pages/Home/Home";

function App() {
  return (
      <BrowserRouter>
        {/*<Sidebar/>*/}
          <Routes>
            <Route exact path="/" element={<Home/>} />
          </Routes>
      </BrowserRouter>
  );
}

export default App;
